export default __webpack_public_path__ + "static/media/2x2_stats.bd54a6f3.svg";